// images.js
import Bear from './Animals/bear.gif';
import Cat from "./Animals/cat.gif";
import Chicken from "./Animals/chicken.gif";
import Cow from "./Animals/cow.gif";
import Deer from "./Animals/deer.gif";
import Dog from "./Animals/dog.gif";
import Duck from "./Animals/duck.gif";
import Frog from "./Animals/frog.gif";
import Giraffe from "./Animals/giraffe.gif";
import Goat from "./Animals/goat.gif";
import Horse from "./Animals/horse.gif";
import Monkey from "./Animals/monkey.gif";
import Mouse from "./Animals/mouse.gif";
import Pig from "./Animals/pig.gif";
import Square from "./Shapes/square.png";
import Circle from "./Shapes/circle.png";
import Diamond from "./Shapes/diamond.png";
import Hexagon from "./Shapes/hexagon.png";
import Octagon from "./Shapes/octagon.png";
import Oval from "./Shapes/oval.png";
import Pentagon from "./Shapes/pentagon.png";
import Rectangle from "./Shapes/rectangle.png";
import Star from "./Shapes/star.png";
import Triangle from "./Shapes/triangle.png";
import Cloudy from "./Weather/cloudy.jpg";
import Rainy from "./Weather/rainy.jpg";
import Snowy from "./Weather/snowy.jpg";
import Sunny from "./Weather/sunny.jpg";
import Windy from "./Weather/windy.jpg";
import Head from "./BodyParts/head.png";
import Ears from "./BodyParts/ears.png";
import Eyes from "./BodyParts/eyes.png";
import Knees from "./BodyParts/knees.png";
import Mouth from "./BodyParts/mouth.png";
import Nose from "./BodyParts/Nose.png";
import Shoulder from "./BodyParts/shoulder.png";
import Toes from "./BodyParts/toes.png";
import Friday from "./Weeks/Friday.png";
import Monday from "./Weeks/Monday.png";
import Saturday from "./Weeks/Saturday.png";
import Sunday from "./Weeks/Sunday.png";
import Thursday from "./Weeks/Thursday.png";
import Tuesday from "./Weeks/Tuesday.png";
import Wednesday from "./Weeks/Wednesday.png";
import Image1 from "./carousel/1.jpg";
import Image2 from "./carousel/2.jpg";
import Image3 from "./carousel/3.jpg";
import Image4 from "./carousel/4.jpg";
import Image5 from "./carousel/5.jpg";
import Teacher1 from "./Teachers/1.jpeg";
import Teacher2 from "./Teachers/2.png";
import Teacher3 from "./Teachers/3.png";
import Teacher4 from "./Teachers/4.png";
import Fb from "./Icons/fb.png";
import Twitter from "./Icons/twitter.png";
import YouTube from "./Icons/youtube.png";
import Ig from "./Icons/ig.png";
import TeacherMay from "./Teachers/May.gif";
import TeacherLolove from "./Teachers/Lolove.gif";
import TeacherRej from "./Teachers/Rej.gif";
import TeacherDonna from "./Teachers/Donna.gif";

const images = {
  Bear:Bear,
  Cat:Cat,
  Chicken:Chicken,
  Cow:Cow,
  Deer:Deer,
  Dog:Dog,
  Duck:Duck,
  Frog:Frog,
  Giraffe:Giraffe,
  Goat:Goat,
  Horse:Horse,
  Monkey:Monkey,
  Mouse:Mouse,
  Pig:Pig,
  Square:Square,
  Circle:Circle,
  Diamond:Diamond,
  Hexagon:Hexagon,
  Octagon:Octagon,
  Oval:Oval,
  Pentagon:Pentagon,
  Rectangle:Rectangle,
  Star:Star,
  Triangle:Triangle,
  Cloudy:Cloudy,
  Rainy:Rainy,
  Snowy:Snowy,
  Sunny:Sunny,
  Windy:Windy,
  Head:Head,
  Shoulder:Shoulder,
  Knees:Knees,
  Toes:Toes,
  Eyes:Eyes,
  Ears:Ears,
  Mouth:Mouth,
  Nose:Nose,
  Sunday:Sunday,
  Monday:Monday,
  Tuesday:Tuesday,
  Thursday:Thursday,
  Wednesday:Wednesday,
  Friday:Friday,
  Saturday:Saturday,
  Image1:Image1,
  Image2:Image2,
  Image3:Image3,
  Image4:Image4,
  Image5:Image5,
  Teacher1:Teacher1,
  Teacher2:Teacher2,
  Teacher3:Teacher3,
  Teacher4:Teacher4,
  Fb:Fb,
  YouTube:YouTube,
  Twitter:Twitter,
  Ig:Ig,
  TeacherMay:TeacherMay,
  TeacherLolove:TeacherLolove,
  TeacherRej:TeacherRej,
  TeacherDonna:TeacherDonna,
  

  // Add other images as needed
};

export default images;